export class Option {
  key: string;
  value: string;

  // only for filtering payment currency
  payMethod?: string;

  constructor(key: string, value: string) {
    this.key = key;
    this.value = value;
  }
}
